import icon from "../../assets/smartdetect.svg";
import type { Property } from "../../types";

export const enhancedDetections: Property = {
  id: "enhancedDetections",
  title: "enhancedDetections.title",
  icon,
};
